import { createContext, useContext } from 'react';

export const EWGContext = createContext(null);
export const useEWGContext = () => useContext(EWGContext);
